export default __webpack_public_path__ + "static/128-min-min-2db4c6414adafaf342fd784b53c9e2cc.jpg";